import React from 'react'
import { createStyles, makeStyles } from '@mui/styles'

interface PickingRouteMissingPiecesProps {
  quantity: number
}

export const PickingRouteMissingPieces: React.FC<PickingRouteMissingPiecesProps> =
  ({ quantity }) => {
    const classes = useStyles()

    const missingStyle =
      quantity > 0 ? classes.missingUnits : classes.pickingRouteComplete

    const text = quantity > 0 ? `PIEZAS FALTANTES ${quantity} Un.` : 'COMPLETA'

    return <p className={missingStyle}>{text}</p>
  }

export const useStyles = makeStyles(() =>
  createStyles({
    missingUnits: {
      color: '#fd2e2e',
      display: 'contents',
      fontWeight: 'bold'
    },
    pickingRouteComplete: {
      display: 'contents',
      color: 'rgb(26, 189, 0)',
      fontWeight: 'bold'
    }
  })
)
